<div class="card-base">
    <div class="card-content-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{filt.toolTip}}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>
        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-right div-header-right">
                    <button (click)="create()" class="card-inline margin-top-medium" type="button" mat-mini-fab>
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-medical-fee-payment-manual-filter #filters></app-medical-fee-payment-manual-filter>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="card-content margin-botton-medium">
                <p-scrollPanel styleClass="scroll-panel">
                    <table class="search-table search-table-fixed" mat-table [dataSource]="dataSource">
                        <ng-container matColumnDef="Id">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control tile="Número" #resColNumber></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                {{ element.Id }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Physician">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control tile="Médico" #resColNumber></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                {{ element.Physician }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Amount">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control tile="Monto" #resColNumber></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                {{ element.Amount }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="PayDate">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control tile="Fecha pago" #resColNumber></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                {{ element.PayDate | date : 'dd/MM/yyyy' }}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="MedicalFeePeriodName">
                            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control tile="Fecha pago" #resColNumber></resizable-column-control>
                            </th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                {{ element.MedicalFeePeriodName }}
                            </td>
                        </ng-container>
                        <!-- Star Column -->
                        <ng-container matColumnDef="Star" stickyEnd>
                            <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
                            <td class="search-table-cell" mat-cell *matCellDef="let element">
                                <mat-spinner *ngIf="element.Loading" [diameter]="20">
                                </mat-spinner>
                                <button *ngIf="!element.Loading" mat-icon-button [matMenuTriggerFor]="menuItem">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menuItem="matMenu">
                                    <button mat-menu-item (click)="cancel(element)"><span>Cancelar liquidación</span></button>
                                    <button mat-menu-item (click)="viewReport(element)"><span>Ver liquidación</span></button>
                                </mat-menu>
                            </td>
                        </ng-container>
                        <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </p-scrollPanel>
                <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>